
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gallery/post/[id]",
      function () {
        return require("private-next-pages/gallery/post/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gallery/post/[id]"])
      });
    }
  